export const auditLeadEndpoint = 'https://api.digitalwerks.com/mautic/audit-lead';
export const auditDownloadEndpoint = 'https://api.digitalwerks.com/mautic/audit-download';
export const auditToolPath = '/marketing-data-confidence-audit-tool';
export const auditAccessKey = 'reportwerks-marketing-audit-access-v2';

export const getAuditAccess = () => {
  try {
    const access = JSON.parse(window.localStorage.getItem(auditAccessKey));
    return access?.token && access.expiresAt > Date.now() ? access : null;
  } catch { return null; }
};

export const hasAuditAccess = () => {
  if (typeof window === 'undefined') return false;
  return Boolean(getAuditAccess());
};

export const grantAuditAccess = (access) => {
  if (typeof window === 'undefined') return;
  if (!access?.token || !(access.expiresAt > Date.now())) throw new Error('Unable to confirm audit access. Please try again.');
  window.localStorage.setItem(auditAccessKey, JSON.stringify(access));
};
